import { createSlice, PayloadAction } from 'ngrx-slice';

import {
  ProductSortimentEntryPricingUpdateRequest,
  ProductSortimentsPricingRequest,
  ProductSortimentsPricingResponse,
} from '@app/api/marketplace/models';

export interface State {
  // selectedProducts - get
  selectedProductIds: ProductSortimentsPricingRequest;
  selectedProductsLoadError: boolean;
  selectedProductsLoading: boolean;
  selectedProducts: Array<ProductSortimentsPricingResponse>;
  pricesSavingLoading: boolean;
  pricesSaveError: boolean;
}

export const initialState: State = {
  // selectedProducts - get
  selectedProductIds: {
    productSortimentIds: [],
  },
  selectedProductsLoading: false,
  selectedProductsLoadError: false,
  selectedProducts: [],
  pricesSavingLoading: false,
  pricesSaveError: false,
};

export const {
  actions: SelectedProductsActions,
  selectors,
  ...SelectedProductsFeature
} = createSlice({
  name: 'selectedProducts',
  initialState,
  reducers: {
    loadSelectedProducts: {
      trigger: (
        state,
        action: PayloadAction<{
          selectedProductIds: ProductSortimentsPricingRequest;
        }>
      ) => {
        state.selectedProducts = [];
        state.selectedProductIds = action.selectedProductIds;
        state.selectedProductsLoading = true;
      },
      success: (
        state,
        action: PayloadAction<{
          response: Array<ProductSortimentsPricingResponse>;
        }>
      ) => {
        state.selectedProducts = action.response;
        state.selectedProductsLoading = false;
        state.selectedProductsLoadError = false;
      },
      failure: (state) => ({
        ...state,
        selectedProductsLoading: false,
        selectedProductsLoadError: true,
      }),
    },
    updatePrices: {
      trigger: (
        state,
        action: PayloadAction<{
          data: Array<ProductSortimentEntryPricingUpdateRequest>;
        }>
      ) => {
        state.pricesSavingLoading = true;
        state.pricesSaveError = false;
      },
      success: (state, action: PayloadAction) => {
        state.pricesSavingLoading = false;
      },
      failure: (state) => ({
        ...state,
        pricesSavingLoading: false,
        pricesSaveError: true,
      }),
    },
    reset: (_) => initialState,
  },
});

export const SelectedProductsSelectors = {
  ...selectors,
};
